function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import themeNames from "../themeNames";
import defaultTheme from "./upgrade";
import * as upgradePalette from "../palette/upgrade";
import * as paletteOverrides from "../palette/universal";
export default _objectSpread(_objectSpread({}, defaultTheme), {}, {
  name: themeNames.UNIVERSAL_CREDIT_THEME_NAME,
  // New colors to use in all apps and components
  palette: _objectSpread(_objectSpread({}, upgradePalette), paletteOverrides),
  // Everything below this line that is a color should be deprecated

  brandName: "Universal Credit",
  minLoanAmount: 1000,
  // @deprecated - use defaultMinLoanAmount instead
  maxLoanAmount: 50000,
  // @deprecated - use defaultMaxLoanAmount instead
  defaultMinLoanAmount: 1000,
  defaultMaxLoanAmount: 50000,
  defaultMetaUrl: "https://www.universal-credit.com",
  defaultMetaTitle: "Personal Loans up to $25,000",
  defaultMetaDescription: "Personal loans with fixed rates and predictable payments. Check your rate with no impact to your credit score.",
  defaultMetaImage: "https://www.universal-credit.com/img/53600710-0-beach-pic.jpg",
  borrowerDashboardLoginMetaTitle: "Sign in",
  borrowerDashboardLoginMetaDescription: "Sign in to securely access your Universal Credit account. Personal loans with fixed rates and predictable payments.",
  publicSiteLendingPartnersPagePath: "/bank-partners",
  borrowerDashboardLoginPageProductCardLinks: [{
    title: "Personal Loans",
    description: "Borrow up to $40,000",
    link: "/funnel/personal-information-1?step=contact&utm_source=deactivated"
  }],
  borrowerDashboardLoginPageProductDisclaimers: [],
  betterBusinessBureauBadge: {
    link: "https://www.bbb.org/us/ca/san-francisco/profile/loans/universal-credit-1116-925612/#sealclick",
    imageSrc: "https://seal-goldengate.bbb.org/seals/black-seal-280-80-bbb-876655.png",
    alt: "Universal Credit, Inc. BBB Business Review"
  },
  trustedSite: {
    link: "https://www.trustedsite.com/verify?host=universal-credit.com",
    imageSrc: "https://cdn.ywxi.net/meter/universal-credit.com/202.svg"
  },
  footerBankNoticePersonalLoanText: "All loans made by our ",
  footerBankNoticePersonalLoanWithAutoRefinanceText: "Personal Loans and Auto Refinance Loans made by our ",
  primary: "#3f465f",
  primaryLight: "#393f55",
  primaryLighter: "#4f5876",
  primaryLightest: "#596385",
  primaryUltraLight: "#9ca2c1",
  partnerPageBackground: "#fff",
  textColorImageBgOverlay: "#3f465f",
  containerBgOverlay: "#fff",
  primaryAccentColor: "#373d52",
  blue: "#0872e4",
  linkColor: "#0872e4",
  linkHoverColor: "#1679e4",
  // Primary
  btnPrimaryBackground: "#0872e4",
  btnPrimaryBorder: "2px solid #0872e4",
  btnPrimaryTextColor: "#fff",
  // Primary Hover
  btnPrimaryBackgroundHover: "#1679e4",
  btnPrimaryBorderHover: "2px solid #1679e4",
  btnPrimaryTextColorHover: "#fff",
  // Active & Focus
  btnPrimaryBackgroundActive: "#0a68cd",
  btnPrimaryBorderActive: "2px solid #0a68cd",
  btnPrimaryTextColorActive: "#fff",
  // Secondary
  btnSecondaryBackground: "#fff",
  btnSecondaryBorder: "2px solid #0872e4",
  btnSecondaryTextColor: "#0872e4",
  // Secondary Hover
  btnSecondaryBackgroundHover: "#1679e4",
  btnSecondaryBorderHover: "2px solid #1679e4",
  btnSecondaryTextColorHover: "#fff",
  // Secondary Active & Focus
  btnSecondaryBackgroundActive: "#0a68cd",
  btnSecondaryBorderActive: "2px solid #0a68cd",
  btnSecondaryTextColorActive: "#fff",
  // Neutral
  btnNeutralBackground: "#fff",
  btnNeutralBorder: "2px solid #e7e5e3",
  btnNeutralTextColor: "#0872e4",
  // Neutral Hover
  btnNeutralBackgroundHover: "#f5f4f3",
  btnNeutralBorderHover: "2px solid #f5f4f3",
  btnNeutralTextColorHover: "#1679e4",
  // Neutral Active & Focus
  btnNeutralBackgroundActive: "#dbd8d6",
  btnNeutralBorderActive: "2px solid #dbd8d6",
  btnNeutralTextColorActive: "#0a68cd",
  // Footer
  footerBackground: "#3f465f",
  footerTextColor: "#fff",
  footerMenuCategoryColor: "#fff",
  footerMenuLinkColor: "#fff",
  footerMenuLinkUnderlineColor: "#fff",
  footerSocialLinkColor: "#fff"
});
//# sourceMappingURL=universal.js.map